import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import styles from './ConnectMultiple.module.css';

import Container from '../../../../blocks/Container';
import Title from '../../../../elements/Title';
import Image from '../../../../elements/Image';
import Text from '../../../../elements/Text';

const ConnectMultiple = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/connect-multiple.md/" } }) {
        edges {
          node {
            frontmatter {
              title
              texts
            }
          }
        }
      }
    }
  `);

  const { title, texts } = data.allMarkdownRemark.edges[0].node.frontmatter;

  return (
    <div className={styles.slideContainer}>
      <Container type="big">
        <Container type="mobile">
          <div className="row">
            <div className="col-12">
              <Title className={styles.title}>{title}</Title>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-12 d-flex flex-column align-items-xl-center align-items-lg-start align-items-center">
              {
                texts.map((text, index) => <Text key={index} className={styles.text}>{text}</Text>)
              }
            </div>
            <div className="col-xl-6 col-lg-6 col-12 offset-xl-1 offset-lg-1 d-flex flex-column align-items-xl-end align-items-lg-end align-items-center">
              <Image name="campaigns/together" className={styles.image} />
            </div>
          </div>
        </Container>
      </Container>
    </div>
  )

}

export default ConnectMultiple;